import React from "react";
import ContentBox, { ContentBoxProps } from "@/src/components/Box/ContentBox/ContentBox";

export type HintBoxProps = { headline: Required<ContentBoxProps["headline"]> } & ContentBoxProps;

// TODO: In long run replace with ContentBox
export default function HintBox({ headline, headlineVariant = "h5", showDivider = true, ...contentBoxProps }: HintBoxProps) {
  return <ContentBox headline={<strong>{headline}</strong>} headlineVariant={headlineVariant} showDivider={showDivider} {...contentBoxProps} />;
}
